'use strict';

angular.module('app').directive('stickyElement', function(utils, $timeout) {
    return function(scope, elem) {

        // disable on mobile
        if (utils.isMobile() && $(elem).attr("disable-mobile")) return;

        var elemOffset;
        $timeout(function () {
            elemOffset = $(elem).offset().top;
        });

        $(window).on('scroll', function() {
            var windowWidth = $(window).outerWidth(),
                $this = $(this)

            if ($this.scrollTop() > elemOffset ) {
                $(elem).addClass('sticky');
            } else {
                $(elem).removeClass('sticky');
            }
        });
    };
});